// =======================================================
// Generator registry — import new generators here
// =======================================================

import { ParticleStorm }  from './ParticleStorm.js';
import { ScanlineFlood }  from './ScanlineFlood.js';
import { DataStream }     from './DataStream.js';
import { PulseGrid }      from './PulseGrid.js';
import { DriftField }     from './DriftField.js';
import { NoiseFlow }      from './NoiseFlow.js';
import { Horizon }        from './Horizon.js';
import { LightFans }      from './LightFans.js';
import { WordGrid }       from './WordGrid.js';
import { ThinkingStream } from './ThinkingStream.js';
import { CosmicSunburst } from './CosmicSunburst.js';
import { GradientWipes }  from './GradientWipes.js';
import { CircuitPulse }   from './CircuitPulse.js';
import { NeuralMesh }     from './NeuralMesh.js';
import { ConnectionAtlas } from './ConnectionAtlas.js';
import { CyberneticTopography } from './CyberneticTopography.js';
import { AIDayLetters }    from './AIDayLetters.js';
import { MatrixRain }      from './MatrixRain.js';
import { CosmicUniverse }  from './CosmicUniverse.js';
import { DinoParade }      from './DinoParade.js';
import { PosterType }      from './PosterType.js';
import { CodeFrame }       from './CodeFrame.js';
import { Stripes }         from './Stripes.js';

// Adding a new generator? Drop a new file in this folder, import it above,
// and add it to the list. UI + hotkeys adapt automatically.
export const GENERATORS = [
  { id: 'particles', key: '1', name: 'Particle Storm', factory: () => new ParticleStorm() },
  { id: 'scan',      key: '2', name: 'Scanline Flood', factory: () => new ScanlineFlood() },
  { id: 'stream',    key: '3', name: 'Data Stream',    factory: () => new DataStream() },
  { id: 'grid',      key: '4', name: 'Pulse Grid',     factory: () => new PulseGrid() },
  { id: 'drift',     key: '5', name: 'Drift Field',    factory: () => new DriftField() },
  { id: 'flow',      key: '6', name: 'Noise Flow',     factory: () => new NoiseFlow() },
  { id: 'horizon',   key: '7', name: 'Horizon Lines',  factory: () => new Horizon() },
  { id: 'lightfans', key: '8', name: 'Light Fans',     factory: () => new LightFans() },
  { id: 'wordgrid',  key: '9', name: 'Word Grid',      factory: () => new WordGrid() },
  { id: 'thinking', key: '0', name: 'Thinking Stream', factory: () => new ThinkingStream() },
  { id: 'sunburst',  key: 'C', name: 'Cosmic Sunburst', factory: () => new CosmicSunburst() },
  { id: 'wipes',     key: 'G', name: 'Gradient Wipes',  factory: () => new GradientWipes() },
  { id: 'circuit',   key: 'P', name: 'Circuit Pulse',   factory: () => new CircuitPulse() },
  { id: 'neural',    key: 'N', name: 'Neural Mesh',     factory: () => new NeuralMesh() },
  { id: 'atlas',     key: 'A', name: 'Connection Atlas', factory: () => new ConnectionAtlas() },
  { id: 'topography',key: 'T', name: 'Cybernetic Topography', factory: () => new CyberneticTopography() },
  { id: 'aidayletters', key: 'L', name: 'AI DAY Letters',    factory: () => new AIDayLetters() },
  { id: 'matrix',    key: 'M', name: 'Matrix Rain',     factory: () => new MatrixRain() },
  { id: 'universe',  key: 'U', name: 'Cosmic Universe', factory: () => new CosmicUniverse() },
  { id: 'dinos',     key: 'D', name: 'Dino Parade',     factory: () => new DinoParade() },
  { id: 'poster',    key: 'B', name: 'Poster Type',     factory: () => new PosterType() },
  { id: 'codeframe', key: 'E', name: 'Code Frame',      factory: () => new CodeFrame() },
  { id: 'stripes',   key: 'S', name: 'Stripes',         factory: () => new Stripes() },
];
